import { render, staticRenderFns } from "./StudentLoginSection.vue?vue&type=template&id=69224989&scoped=true"
import script from "./StudentLoginSection.vue?vue&type=script&lang=js"
export * from "./StudentLoginSection.vue?vue&type=script&lang=js"
import style0 from "./StudentLoginSection.vue?vue&type=style&index=0&id=69224989&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69224989",
  null
  
)

export default component.exports